import { render, staticRenderFns } from "./BindPhoneBox.vue?vue&type=template&id=0a3e3d83"
import script from "./BindPhoneBox.vue?vue&type=script&lang=js"
export * from "./BindPhoneBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports